module.exports = __webpack_public_path__ + "static/schlitten1-b6fcfaf2a7266ad4dfd19d763caaa110.jpg";